import React, { useEffect, useMemo } from "react";
import * as PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import { useEngineData } from "./useEngineDataList";
import { EngineTrendBase } from "./engineTrendBase.jsx";
import { useDetectVesselConnection } from "../../../hooks/useDetectVesselConnection";
import { useDurationHandle } from "../calendarDuration/useDurationHandle.js";
import { DURATION } from "../calendarDuration/durationOption";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { useNavigationData } from "./useNavigationData";
import { convertPositionTextToNumeric } from "../../../helpers/enginePosition.js";

export const EngineTrendGraph = ({
  vesselId = null,
  selectedChart,
  selectedEngine,
  currentVessel,
  setSelectedEngine,
  graphData,
  setGraphData,
  setDataFetchStatus,
  trendCharts,
  isVesselOverview,
  overviewTrendIdx,
  setChartRef,
}) => {
  const { connections } = useDetectVesselConnection();
  const isDisconnected = connections.includes(vesselId);
  const { engineValues, isLoading, isNoData } = useEngineData({
    vesselId,
    position: convertPositionTextToNumeric(selectedEngine),
    isVesselOverview,
  });
  const { navigationValues } = useNavigationData({
    vesselId,
  });

  const passedValues = useMemo(() => {
    return { ...engineValues, ...navigationValues };
  }, [engineValues, navigationValues]);

  useEffect(() => {
    setDataFetchStatus({
      isLoading,
      isNoData,
    });
  }, [isLoading, isNoData]);

  // initial load trigger
  useDurationHandle(DURATION.ENGINE, selectedEngine);

  return (
      <Grid container spacing={2}>
        <Grid item size={{xs: 12}}>
          <EngineTrendBase
            selectedEngine={selectedEngine}
            setSelectedEngine={setSelectedEngine}
            values={passedValues}
            isDurationDisabled={isLoading}
            isNoData={isNoData}
            isDisconnected={isDisconnected}
            vesselId={vesselId}
            vessel={currentVessel}
            isLoading={isLoading}
            selectedChart={selectedChart}
            graphType={GRAPH_TYPE.ENGINE}
            graphData={graphData}
            setGraphData={setGraphData}
            customLineData={trendCharts?.[selectedChart]}
            isVesselOverview={isVesselOverview}
            setChartRef={setChartRef}
            overviewTrendIdx={overviewTrendIdx}
          />
        </Grid>
      </Grid>
  );
};

EngineTrendGraph.propTypes = {
  vesselId: PropTypes.string.isRequired,
  selectedChart: PropTypes.string,
  selectedEngine: PropTypes.string,
  isVesselOverview: PropTypes.bool,
  setChartRef: PropTypes.func,
  overviewTrendIdx: PropTypes.number,
  currentVessel: PropTypes.object,
  setSelectedEngine: PropTypes.func,
  graphData: PropTypes.array,
  setGraphData: PropTypes.func,
  setDataFetchStatus: PropTypes.func,
  trendCharts: PropTypes.array,
};